import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientUserBranchAccessesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    branchId?: string;
    clientUserId?: string;
  }
  mapper?: (data: any) => T
}

export const useClientUserBranchAccesses = <T,>({
  filters: { search = '', page, branchId, clientUserId } = {},
  mapper = Mapper.default<T>(),
}: UseClientUserBranchAccessesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['clientUserBranchAccesses', branchId, clientUserId, search, page],
    queryFn: () => {
      return privateAxios.get(`/client/user_branch_accesses`, {
        params: {
          search,
          page,
          'q[branch_id_eq]': branchId,
          'q[user_id_eq]': clientUserId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse; } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
